// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__lQNKx","description":"MealItem_description__2nmhc","price":"MealItem_price__1-Cmp"};